import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { style: {"max-width":"50rem"} }, " This will add a new user to the workspace. If the user already exists, they can log in with their existing credentials. If the user does not exist, you will receive a link that will allow them to setup their password. ", -1)
const _hoisted_4 = { class: "form-group mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "user-email" }, "Email:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary d-block mt-5",
  type: "submit"
}, "Add to workspace", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"max-width":"50rem"} }, " This user is new to the workspace. Please share the link below with them so they can set their password and log in. ", -1)
const _hoisted_8 = { style: {"max-width":"50rem","word-break":"break-all"} }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary d-block mt-5",
  type: "submit"
}, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add user",
    onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createUser())),
    onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelCreateUser()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.step == 'email')
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createUser && _ctx.createUser(...args)))
              }, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control form-control-lg my-2",
                    id: "user-email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUserEmail) = $event)),
                    placeholder: "Enter email"
                  }, null, 512), [
                    [_vModelText, _ctx.newUserEmail]
                  ])
                ]),
                _hoisted_6
              ], 32))
            : (_ctx.step == 'userdetails')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelCreateUser && _ctx.cancelCreateUser(...args)))
                }, [
                  _hoisted_7,
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("a", {
                      href: _ctx.setPasswordLink,
                      target: "_blank",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, _toDisplayString(_ctx.setPasswordLink), 9, _hoisted_9)
                  ]),
                  _hoisted_10
                ], 32))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}